import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebaseconfig';
import { HiOfficeBuilding, HiUserGroup, HiAcademicCap } from 'react-icons/hi';

const AreaSelector = ({ onAreaSelect, selectedArea }) => {
  const [areas, setAreas] = useState([]);
  const [subareasByArea, setSubareasByArea] = useState({});

  useEffect(() => {
    const fetchAreasAndSubareas = async () => {
      try {
        const areaControllerCollection = collection(db, 'areacontroller');
        const querySnapshot = await getDocs(areaControllerCollection);
        
        const areasData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Filtrar áreas y subáreas
        const filteredAreas = areasData.filter(item => item.type === 'area');
        const filteredSubareas = areasData.filter(item => item.type === 'subarea');
        
        setAreas(filteredAreas);
        groupSubareasByArea(filteredSubareas);
      } catch (error) {
        console.error('Error fetching areas and subareas:', error);
      }
    };

    fetchAreasAndSubareas();
  }, []);

  const groupSubareasByArea = (subareas) => {
    const groupedSubareas = subareas.reduce((acc, subarea) => {
      if (subarea.from) {
        if (!acc[subarea.from]) {
          acc[subarea.from] = [];
        }
        acc[subarea.from].push(subarea);
      }
      return acc;
    }, {});

    setSubareasByArea(groupedSubareas);
  };

  const getIconForAreaOrSubarea = (type) => {
    if (type === 'area') {
      return HiUserGroup;
    } else if (type === 'subarea') {
      return HiOfficeBuilding;
    }
    return HiAcademicCap;
  };

  const handleAreaClick = (name) => {
    console.log('Área o subárea seleccionada:', name);
    onAreaSelect(name.toLowerCase());
  };

  return (
    <div>
      <div className="area-buttons">
        {areas.map(area => (
          <div key={area.name} className="area-container">
            <button 
              onClick={() => handleAreaClick(area.name)} 
              className={`area-button ${selectedArea === area.name.toLowerCase() ? 'selected' : ''}`}
            >
              <getIconForAreaOrSubarea type={area.type} className="area-icon" />
              <span>{area.name}</span>
            </button>

            {/* Subáreas se despliegan al hacer hover sobre el área */}
            <div className="subarea-container">
              {subareasByArea[area.name] && subareasByArea[area.name].map(subarea => (
                <button 
                  key={subarea.name} 
                  onClick={() => handleAreaClick(subarea.name)} 
                  className={`subarea-button ${selectedArea === subarea.name.toLowerCase() ? 'selected' : ''}`}
                >
                  <getIconForAreaOrSubarea type={subarea.type} className="area-icon" />
                  <span>{subarea.name}</span>
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Mostrar todos los documentos */}
      {/* <div>
        <h3>Todos los documentos:</h3>
        <pre>{JSON.stringify({ areas, subareasByArea }, null, 2)}</pre>
      </div> */}
    </div>
  );
};

export default AreaSelector;
